import { gql } from '@apollo/client';

export default gql`
  query templates($page: Int, $name: String, $search: String, $sortBy: String) {
    space {
      adminRole
    }
    templates(page: $page, name: $name, search: $search, sortBy: $sortBy) {
      templatesTotalPages
      templatesTotal
      perPage
      hasNextPage
      templates {
        id
        name
        inspectionsTotal
        templateFieldsTotal
        periodCycle
        periodNumber
      }
    }
  }
`;
